import React from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from 'components/button/PrimaryButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import FullNameTextField from 'components/show/FullNameTextField';

class AccountsOwnerForm extends React.Component {
    render() {
        const {
            handleResetUser,
            translate,
            user,
        } = this.props;

        return (
            <div>
                <FullNameTextField
                    label={ translate('resources.accounts.fields.owner') }
                    record={ user }
                />
                <PrimaryButton label={ translate('actions.edit') } onClick={ () => {
                    handleResetUser();
                } }/>
            </div>
        );
    }
}

AccountsOwnerForm.propTypes = {
    handleResetUser: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

const enhance = compose(
    translate
);

export default enhance(AccountsOwnerForm);



// WEBPACK FOOTER //
// ./src/pages/accounts/create/AccountsOwnerForm.js